module.exports = __webpack_public_path__ + "static/media/wolt.e9e363fd.png";